export default function () {
    (function($) {

        // A global method for toggling the visibility of search within a menu
        $.fn.toggleGlobalSearch = function(show) {
            const target = $($(this).attr('data-target'));
            let doShow = show;

            if (target.hasClass('header-search')) {
                if (doShow === undefined) {
                    doShow = target.hasClass('d-lg-none');
                }

                if (!target.length) {
                    console.warn(`Could not find "data-target" ${$(this).attr('data-target')}`);
                    return;
                }

                target.toggleClass('d-lg-none', !doShow);
                target.next('.navbar-nav').toggleClass('d-lg-none', doShow);
                target.find('input[type="text"]').focus().closest('.input-group').updateInputState();
            }
        };

        // Show search
        $('.show-search').on('click', function(e) {
            $(this).toggleGlobalSearch();
        });

    })(jQuery);
}
